import { useEffect } from 'react';
import { sendAnalyticsPageView } from './analytics';
import type { SendAnalyticsPageViewParams } from './analytics.types';

/**
 * React hook to capture a page view analytics event on React component mount
 * @param {Object} params - Analytics event payload
 */
export const usePageViewAnalytics = (
  params: SendAnalyticsPageViewParams,
  dependencies: Array<unknown> = [],
  /** @deprecated Kept for backwards compatibility. This parameter is ignored. */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _name?: string,
) => {
  if (!Array.isArray(dependencies))
    throw new Error('Provided hook dependencies must be an array');

  useEffect(() => {
    sendAnalyticsPageView(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};
